import { IReduxAction } from '../../views/interfaces';
import { GET_RESERVATIONS_SUMMARY_SUCCESS } from '../actions';

const initialState = {
  data: null  
};

export const reservationsSummaryReducer = (state = initialState, { type, payload }: IReduxAction) => {
  switch (type) {
    case GET_RESERVATIONS_SUMMARY_SUCCESS: {
      return { ...state, data: payload };
    }
    default:
      return state;
  }
}; 